// @ts-nocheck

import axios from 'axios';
import router from '@/router';

/**
 * Class Saas Service
 */
export default class SaasService {

  private axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: {
      'Authorization': `Bearer ${router.app.$auth.token()}`
    }
  });

  public async postTopTerms(firstDate: string, lastDate: string, platformId: number) {
    const params = {
      first_date: firstDate,
      last_date: lastDate,
      id_platform: platformId,
      outbound: false
    }
    return await this.axiosInstance.post('integration/app/top-terms', params).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async getSentiment(firstDate: string, lastDate: string, action?: string, plugin?: string) {
    const params = {
      firstDate: firstDate,
      lastDate: lastDate,
      action: action,
      plugin: plugin
    }
    return await this.axiosInstance.get('integration/app/get-sentiment-platform', { params }).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async getTemplateMessage(platformId: number, action?: string, variables?: string) {
    const params = {
      variables: variables
    }
    return await this.axiosInstance.get(`integration/saas/template-message/${platformId}` + (action ? `/${action}` : ''), { params }).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async createTemplateMessage(platformId: number, params: any, action: number | null) {
    const url = `integration/saas/template-message/${platformId}${!action ? '' : '/' + action}`;
    return await this.axiosInstance.post(url, params).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async updateTemplateMessage(templateId: number, messageStr: string, action?: number) {
    const params = {
      body: messageStr
    }

    let url = `integration/saas/template-message/${templateId}`;
    if (action !== undefined) {
      url += `/${action}`;
    }

    return await this.axiosInstance.put(url, params).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async setTemplateState(idAppTemplatesPlatformAction: number, state: string) {
    return await this.axiosInstance.put(`integration/saas/set-state/template-message/${idAppTemplatesPlatformAction}/${state}`).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async setTemplateStatus(templateId: number, status: string) {
    return await this.axiosInstance.put(`integration/saas/set-status/template-message/${templateId}/${status}`).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async deleteTemplateMessage(idAppTemplatesPlatformAction: number) {
    return await this.axiosInstance.delete(`integration/saas/template-message/${idAppTemplatesPlatformAction}`).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async getFupLifeCycleRules() {
    return await this.axiosInstance.get('solution/lead-lifecycle/rule').then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async createFupLifeCycleRule(payload: any) {
    return await this.axiosInstance.post('solution/lead-lifecycle/rule', payload).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async updateFupLifeCycleRule(rule_id: number, payload: any) {
    return await this.axiosInstance.put(`solution/lead-lifecycle/rule`, payload).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }

  public async getPlatformChannels(platformId: number) {
    return await this.axiosInstance.get(`lead/channel/${platformId}`).then((response: any) => {
      return response.data;
    }, (error: any) => {
      return Promise.reject(error);
    });
  }
}
